import React from 'react';
import classnames from 'classnames';
// import "./Loader.styles.scss";
import { CircularProgress } from '@mui/material';
import { LoaderContainer } from './Loader.styles';


export const Loader:React.FC<{isLoading:boolean}> = ({isLoading}) => {

  return (
    <LoaderContainer className={classnames({'active':isLoading})}>
            {/* <span> Chargement </span> */}
            <CircularProgress color='primary' />
    </LoaderContainer>
  )
}
